module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /home/jm/Lab/www/local/labs/node_modules/axios/index.js
// module id = 287
// module chunks = 0